/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FilterViewScope } from './FilterViewScope';
import {
    FilterViewScopeFromJSON,
    FilterViewScopeFromJSONTyped,
    FilterViewScopeToJSON,
} from './FilterViewScope';

/**
 * 
 * @export
 * @interface CreateFilterViewRequest
 */
export interface CreateFilterViewRequest {
    /**
     * 
     * @type {FilterViewScope}
     * @memberof CreateFilterViewRequest
     */
    scope: FilterViewScope;
    /**
     * 
     * @type {string}
     * @memberof CreateFilterViewRequest
     */
    view_key: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFilterViewRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFilterViewRequest
     */
    description?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateFilterViewRequest
     */
    filters: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof CreateFilterViewRequest
     */
    is_default?: boolean;
}

/**
 * Check if a given object implements the CreateFilterViewRequest interface.
 */
export function instanceOfCreateFilterViewRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "scope" in value;
    isInstance = isInstance && "view_key" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "filters" in value;

    return isInstance;
}

export function CreateFilterViewRequestFromJSON(json: any): CreateFilterViewRequest {
    return CreateFilterViewRequestFromJSONTyped(json, false);
}

export function CreateFilterViewRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFilterViewRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'scope': FilterViewScopeFromJSON(json['scope']),
        'view_key': json['view_key'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'filters': json['filters'],
        'is_default': !exists(json, 'is_default') ? undefined : json['is_default'],
    };
}

export function CreateFilterViewRequestToJSON(value?: CreateFilterViewRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'scope': FilterViewScopeToJSON(value.scope),
        'view_key': value.view_key,
        'name': value.name,
        'description': value.description,
        'filters': value.filters,
        'is_default': value.is_default,
    };
}

